import script from "./Actions.vue?vue&type=script&setup=true&lang=js"
export * from "./Actions.vue?vue&type=script&setup=true&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=73d8460d&scoped=true&lang=scss"
script.__scopeId = "data-v-73d8460d"

export default script